// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landingPage {
  padding-left: 74px;
  padding-right: 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  height: 100vh;
  padding-bottom: 40px;
}

.landingPage h2 {
  margin: 0;
  padding: 0;
  color: #4a88b1;
}

.h2-subtitle {
  color: #333 !important;
  margin-top: 40px !important;
}

.landingPage h3 {
  margin-bottom: 40px;
}

h4 {
  font-size: 14px;
  margin-bottom: 40px;
  text-decoration: underline;
}

.collaborators-div {
  margin-top: 30px;
}

.collaborators-img {
  margin-top: 10px;
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
}

.relationship-elements {
  width: 100%;
  max-width: 724px;
  margin: 14px auto 0 auto;
  display: block;
  overflow: visible;
}

.footer {
  width: 100vw;
  height: Fixed (49px) px;
  min-width: 100%;
  gap: 174px;
  margin-top: 3%;
  padding-bottom: 2%;
}

.footer-text {
  font-size: 11px;
  color: #4a88b1;
}

@media (max-width: 500px) {
  .landingPage {
    height: 100vw;
    width: -moz-fit-content !important;
    width: fit-content !important;
    margin-right: 0px;
    margin-top: 76px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LandingPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,kCAAkC;IAClC,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".landingPage {\n  padding-left: 74px;\n  padding-right: 16px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  height: 100vh;\n  padding-bottom: 40px;\n}\n\n.landingPage h2 {\n  margin: 0;\n  padding: 0;\n  color: #4a88b1;\n}\n\n.h2-subtitle {\n  color: #333 !important;\n  margin-top: 40px !important;\n}\n\n.landingPage h3 {\n  margin-bottom: 40px;\n}\n\nh4 {\n  font-size: 14px;\n  margin-bottom: 40px;\n  text-decoration: underline;\n}\n\n.collaborators-div {\n  margin-top: 30px;\n}\n\n.collaborators-img {\n  margin-top: 10px;\n  height: 50px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.relationship-elements {\n  width: 100%;\n  max-width: 724px;\n  margin: 14px auto 0 auto;\n  display: block;\n  overflow: visible;\n}\n\n.footer {\n  width: 100vw;\n  height: Fixed (49px) px;\n  min-width: 100%;\n  gap: 174px;\n  margin-top: 3%;\n  padding-bottom: 2%;\n}\n\n.footer-text {\n  font-size: 11px;\n  color: #4a88b1;\n}\n\n@media (max-width: 500px) {\n  .landingPage {\n    height: 100vw;\n    width: -moz-fit-content !important;\n    width: fit-content !important;\n    margin-right: 0px;\n    margin-top: 76px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
